import { useEffect } from 'react'
import { useLocation } from '@redwoodjs/router'
import { trackPageView } from '../../lib/gtm'

const PageViewTracker: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    const url = location.pathname + (location.search || '')
    const pageTitle = document.title || 'Lagshoppen'
    const pageLocation = window.location.href

    // Track the page view using GTM utility
    trackPageView(url, pageLocation, pageTitle)
  }, [location.pathname, location.search])

  return null
}

export default PageViewTracker
